// extracted by mini-css-extract-plugin
export var root = "blog-post-preview-list-module--root--MTrX3";
export var headline = "blog-post-preview-list-module--headline--N2M1N";
export var grid = "blog-post-preview-list-module--grid--moyeN";
export var browseMoreNav = "blog-post-preview-list-module--browseMoreNav--JloXi typography-module--small--Jy8K4";